import React from 'react';
import { Box, Skeleton, TextField } from '@mui/material';

const SearchSkeleton = () => {
  return (
    <Box sx={{ width: '100%', padding: 2 , display:'flex', flexDirection:'column', alignItems:'center'}}>
      {/* Input Field */}
      <TextField
        variant="outlined"
        placeholder="Search..."
        disabled
        sx={{ marginBottom: 2, width: '80%' }}
      />

      {/* Skeleton Boxes */}
      {[...Array(10)].map((_, index) => (
        <Box
        key={index}
        height={100}
        width="80%"
        sx={{ marginBottom: 1, borderRadius: 3, padding: 2 }}
      >
        {/* Product info layout */}
        <Box sx={{ display: 'flex', height: '100%' }}>
          {/* Left square image placeholder */}
          <Skeleton
            variant="rectangular"
            width={80}
            height={80}
            sx={{ borderRadius: 2, marginRight: 2 }}
          />
      
          {/* Right section */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            {/* Title placeholder */}
            <Skeleton
              variant="text"
              width="70%"
              height={20}
              sx={{ marginBottom: 1 }}
            />
      
            {/* Classification tag placeholder */}
            <Skeleton
              variant="rounded"
              width={100}
              height={20}
              sx={{ marginBottom: 1 }}
            />
      
            {/* Additional text placeholder */}
            <Skeleton
              variant="text"
              width="90%"
              height={15}
              sx={{ marginBottom: 1 }}
            />
      
            {/* Bottom-right small images */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 2 }} />
            </Box>
          </Box>
        </Box>
      </Box>
      
      ))}
      
    </Box>
  );
};

export default SearchSkeleton;
